export enum SkeletonAppearance {
  CIRCLE = 'circle',
  LINE = 'line',
  CUSTOM_CONTENT = 'custom-content',
}
